// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconFolderSearch = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '36',
      height: '30',
      viewBox: '0 0 36 30',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.1464 28.8967H5.40162C3.08201 28.8967 1.2016 27.0162 1.20162 24.6966L1.20178 8.7291C1.20179 7.12974 1.20119 4.85171 1.20068 3.20225C1.20033 2.04214 2.14066 1.10278 3.30077 1.10278H13.3076L18.1464 6.27165H32.7C33.8598 6.27165 34.8 7.21185 34.8 8.37165V13.9499M31.65 26.5499L33.75 28.6499M32.7 22.3499C32.7 25.2494 30.3495 27.5999 27.45 27.5999C24.5505 27.5999 22.2 25.2494 22.2 22.3499C22.2 19.4504 24.5505 17.0999 27.45 17.0999C30.3495 17.0999 32.7 19.4504 32.7 22.3499Z',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconFolderSearch };
